/**
 * O TERMINAL da bancada: a aba do navegador onde ela roda. Uma máquina fica
 * com UM operador num terminal só; é este id que distingue dois terminais,
 * mesmo com o mesmo crachá. Fica no sessionStorage: recarregar a página mantém
 * o terminal (a máquina continua com ele), outra aba é outro terminal.
 */
const TERMINAL_STORAGE_KEY = 'wms.bancada.terminal';

function newTerminalId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `t-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function GetBenchTerminalId() {
    try {
        const stored = sessionStorage.getItem(TERMINAL_STORAGE_KEY);
        if (stored) {
            return stored;
        }
        const created = newTerminalId();
        sessionStorage.setItem(TERMINAL_STORAGE_KEY, created);
        return created;
    } catch {
        // navegador sem storage: o terminal vale enquanto a tela estiver aberta
        return newTerminalId();
    }
}
